/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Lv_ErrorInputs */

const cs_property_registry_lv_error = /** @type {(inputs: Property_Registry_Lv_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stažení výpisu LV selhalo.`)
};

const en_property_registry_lv_error = /** @type {(inputs: Property_Registry_Lv_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LV extract download failed.`)
};

/**
* | output |
* | --- |
* | "LV extract download failed." |
*
* @param {Property_Registry_Lv_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_lv_error = /** @type {((inputs?: Property_Registry_Lv_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Lv_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_lv_error(inputs)
	return cs_property_registry_lv_error(inputs)
});